import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    TablePaginationPadrao,
    rowPertentePage,
    setPageInclusao,
    setPageExclusao,
} from '../../../business-components/Pagination/Pagination'

import {
    TextValidatorText,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import tipoSolicitacaoArquivoList from '../../../business-rules/List/Arquivo/tipoSolicitacaoArquivoList'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

//import {
//    processaAlteracaoEducacaoTipoEducacao,
//    processaAlteracaoEducacaoIdadeFinal,
//    processaAlteracaoEducacaoTemSeguro,
//} from './DespesasServiceEducacao'



export const TablePaginationPadraoSolicitacaoArquivo = ({ values, setFieldValue }) => {

    return (
        <TablePaginationPadrao
            setFieldValue={setFieldValue}
            list={values.solicitacaoArquivoPagination}
            nameRowsPerPage={'rowsPerPageSolicitacaoArquivo'}
            namePage={'pageSolicitacaoArquivo'}
            rowsPerPage={values.rowsPerPageSolicitacaoArquivo}
            page={values.pageSolicitacaoArquivo}
        />
    )
}



export const rowPertentePageSolicitacaoArquivo = (values, indAux) => {
    
    return rowPertentePage(indAux, values.pageSolicitacaoArquivo, values.rowsPerPageSolicitacaoArquivo)
}



export const setPageInclusaoSolicitacaoArquivo = (values, setFieldValue) => {

    return setPageInclusao(setFieldValue, 'pageSolicitacaoArquivo',
        values.solicitacaoArquivoPagination, values.rowsPerPageSolicitacaoArquivo)
}



export const TipoSolicitacaoArquivo = ({ item, ind, handleChange, disabled }) => {

    return (
        <TextFieldNumberSelect
            name={`solicitacaoArquivo[${ind}].tipoSolicitacaoArquivo`}
            placeholder={LABEL.tipoSolicitacaoArquivo}
            value={item.tipoSolicitacaoArquivo || ''}
            onChange={handleChange}
            list={tipoSolicitacaoArquivoList}
            disabled={disabled}
        />
    )
}



export const ObservacaoSolicitacaoArquivo = ({ item, ind, handleChange, disabled }) => {

    return (
        <TextValidatorText
            name={`solicitacaoArquivo[${ind}].observacaoSolicitacaoArquivo`}
            label={LABEL.observacao}
            value={item.observacaoSolicitacaoArquivo || ''}
            onChange={handleChange}
            tamMax={TAMMAX.observacaoSolicitacaoArquivo}
            notToUpperCase={true}
            disabled={disabled}
            //disabled={expandiu}
        />
    )
}



export const IconButtonClearEntradaDadosSolicitacaoArquivo = ({ values, setFieldValue, ind,
    arrayHelpers/*, simplificado*/, arquivoListSolicitacaoArquivo }) => {

    return (
        //!simplificado
        //    ?
                <IconButtonClearEntradaDados
                    onClick={() => {
                        arrayHelpers.remove(ind)
                        setPageExclusao(setFieldValue, 'pageSolicitacaoArquivo',
                            values.solicitacaoArquivoPagination, values.rowsPerPageSolicitacaoArquivo,
                                values.pageSolicitacaoArquivo)
                    }}
                    disabled={
                        arquivoListSolicitacaoArquivo.length > 0 ||
                        values.jsonAcessoCliente.acessoCliente
                    }
                />
        //    :
        //        ''
    )
}